// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xF5d","rootMobile":"styles_rootMobile__3oPky"};